import { ApolloClient } from "apollo-client";
import { ApolloLink } from "apollo-link";
import { HttpLink } from "apollo-link-http";
import { RetryLink } from "apollo-link-retry";
// import { onError } from "apollo-link-error";
import { setContext } from "apollo-link-context";
import { InMemoryCache } from "apollo-cache-inmemory";
// import { SubscriptionClient, addGraphQLSubscriptions } from 'subscriptions-transport-ws';

import { NETWORK_INTERFACE_URL } from "config";
import { CONSTANTS } from "@lifepay/redux-subsystem-user";

// const SUBSCRIPTION_CLIENT_URL = 'wss://subscriptions.graph.cool/v1/API_KEY';

// const networkInterface = createNetworkInterface({ uri: NETWORK_INTERFACE_URL });
// const wsClient = new SubscriptionClient(SUBSCRIPTION_CLIENT_URL, {
//   reconnect: true,
// });

// const networkInterfaceWithSubscriptions = addGraphQLSubscriptions(
//   networkInterface,
//   wsClient

// export const errorBus = new EventEmitter();

// const errors = [];

// const errorHandler = onError(({ response, operation }) => {
//   console.log(errors);
//   if (errors.includes(operation.operationName)) {
//     response.errors = null;
//     console.log("clearing errors");
//   }
//   errors.push(operation.operationName);
//   console.log(errors);
// });

const authLink = setContext((_, { headers }) => {
  // get the authentication token from local storage if it exists
  const token = localStorage.getItem(CONSTANTS.LOCAL_STORAGE_PRIMARY_KEY);
  // return the headers to the context so httpLink can read them
  return {
    headers: {
      ...headers,
      authorization: token ? `JWT ${token}` : "",
    },
  };
});

const withRetries = new RetryLink({
  delay: {
    initial: 300,
    max: 30 * 1000,
  },
  attempts: (count, operation, error) => {
    console.dir(error);
    let retry = false;
    if (error) {
      console.log(`Error status code ${error.statusCode}`);
      if (
        error.statusCode !== 400 &&
        error.statusCode !== 401 &&
        error.statusCode !== 403 &&
        error.statusCode !== 500
      ) {
        retry = true;
      }
      if (error.statusCode === 500 && count > 2) {
        retry = false;
      }
      if (count > 3) {
        retry = false;
      }
    }
    if (retry) {
      console.log(
        `Retrying operation ${operation.operationName} (Attempt ${count})`
      );
    }
    return retry;
  },
});

const httpLink = new HttpLink({ uri: NETWORK_INTERFACE_URL });

let link = ApolloLink.from([
  // combine links
  // errorHandler,
  authLink,
  withRetries,
  httpLink,
]);

const client = new ApolloClient({
  link,
  cache: new InMemoryCache(),
});

export default client;



// WEBPACK FOOTER //
// ./src/model/client.js